/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import { getPrice } from 'Util/Product/Extract';

import ProductLabels from '../component/ProductLabels';

const propTypes = (member) => ({
    ...member,
    labels: PropTypes.array.isRequired
});

const containerProps = (args, callback, instance) => {
    const { product: { sf_labels = '', price_range } = {} } = instance.props;

    const { price: { discount }} = getPrice(price_range);

    return {
        ...callback(...args),
        discount,
        sf_labels
    };
};

const addLabelComponentToProductGalleryComponent = (args, callback, instance) => {
    const { discount, sf_labels } = instance.props;
    const component = callback(...args);

    const extendedChildren = [
        <ProductLabels sf_labels={ sf_labels } discount={ discount } />,
        ...component.props.children
    ];

    return cloneElement(
        component,
        {
            ...component.props,
            // vvv Added mod for styling
            className: `${ component.props.className } Checkout_isConfirmationFailed`
        },
        extendedChildren
    );
};

export default {
    'Component/ProductGallery/Component': {
        'static-member': {
            propTypes
        },
        'member-function': {
            render: addLabelComponentToProductGalleryComponent
        }
    },
    'Component/ProductGallery/Container': {
        'member-function': {
            containerProps
        }
    }
};
